import { __awaiter, __generator } from "tslib";
import * as constants from './constants';
import { getText, isPageUrlAllowed, getAttributesWithPrefix, removeEmptyProperties, getNearestLabel, querySelectUniqueElements, getClosestElement, getSelector, debounce, } from './helpers';
export var DEFAULT_CSS_SELECTOR_ALLOWLIST = [
    'a',
    'button',
    'input',
    'select',
    'textarea',
    'label',
    '[data-amp-default-track]',
    '.amp-default-track',
];
export var DEFAULT_DATA_ATTRIBUTE_PREFIX = 'data-amp-track-';
export var defaultEventTrackingAdvancedPlugin = function (options) {
    if (options === void 0) { options = {}; }
    var _a = options.debounceChange, debounceChange = _a === void 0 ? 500 : _a, _b = options.trackForm, trackForm = _b === void 0 ? true : _b, 
    // trackPosition = false,
    _c = options.cssSelectorAllowlist, 
    // trackPosition = false,
    cssSelectorAllowlist = _c === void 0 ? DEFAULT_CSS_SELECTOR_ALLOWLIST : _c, pageUrlAllowlist = options.pageUrlAllowlist, shouldTrackEventResolver = options.shouldTrackEventResolver, _d = options.dataAttributePrefix, dataAttributePrefix = _d === void 0 ? DEFAULT_DATA_ATTRIBUTE_PREFIX : _d;
    var name = constants.PLUGIN_NAME;
    var type = 'enrichment';
    var observer;
    var eventListeners = [];
    var logger = undefined;
    var debouncedTracks = new WeakMap();
    var addEventListener = function (element, type, handler) {
        element.addEventListener(type, handler);
        eventListeners.push({
            element: element,
            type: type,
            handler: handler,
        });
    };
    var removeEventListeners = function () {
        eventListeners.forEach(function (_ref) {
            var _a, _b;
            var element = _ref.element, type = _ref.type, handler = _ref.handler;
            /* istanbul ignore next */
            element === null || element === void 0 ? void 0 : element.removeEventListener(type, handler);
            (_b = (_a = debouncedTracks.get(element)) === null || _a === void 0 ? void 0 : _a.flush) === null || _b === void 0 ? void 0 : _b.call(_a);
            debouncedTracks.delete(element);
        });
        eventListeners = [];
    };
    var shouldTrackEvent = function (actionType, element) {
        var _a, _b;
        /* istanbul ignore if */
        if (!element) {
            return false;
        }
        /* istanbul ignore next */
        var tag = (_b = (_a = element === null || element === void 0 ? void 0 : element.tagName) === null || _a === void 0 ? void 0 : _a.toLowerCase) === null || _b === void 0 ? void 0 : _b.call(_a);
        // Text nodes have no tag
        if (!tag) {
            return false;
        }
        if (shouldTrackEventResolver) {
            return shouldTrackEventResolver(actionType, element);
        }
        if (!isPageUrlAllowed(window.location.href, pageUrlAllowlist)) {
            return false;
        }
        /* istanbul ignore next */
        var elementType = (element === null || element === void 0 ? void 0 : element.type) || '';
        if (typeof elementType === 'string') {
            switch (elementType.toLowerCase()) {
                case 'hidden':
                    return false;
                case 'password':
                    return false;
            }
        }
        /* istanbul ignore if */
        if (cssSelectorAllowlist) {
            var hasMatchAnyAllowedSelector = cssSelectorAllowlist.some(function (selector) { var _a; return !!((_a = element === null || element === void 0 ? void 0 : element.matches) === null || _a === void 0 ? void 0 : _a.call(element, selector)); });
            if (!hasMatchAnyAllowedSelector) {
                return false;
            }
        }
        switch (tag) {
            case 'input':
            case 'select':
            case 'textarea':
                return actionType === 'change' || actionType === 'click';
            default:
                return actionType === 'click';
        }
    };
    var getEventProperties = function (actionType, element) {
        var _a;
        var _b, _c, _d, _e, _f, _g;
        /* istanbul ignore next */
        var tag = (_c = (_b = element === null || element === void 0 ? void 0 : element.tagName) === null || _b === void 0 ? void 0 : _b.toLowerCase) === null || _c === void 0 ? void 0 : _c.call(_b);
        var ariaLabel = element.getAttribute('aria-label');
        var attributes = getAttributesWithPrefix(element, dataAttributePrefix);
        var nearestLabel = getNearestLabel(element);
        var selector = getSelector(element, logger);
        /* istanbul ignore next */
        var properties = (_a = {},
            _a[constants.AMPLITUDE_EVENT_PROP_ELEMENT_ID] = element.id,
            _a[constants.AMPLITUDE_EVENT_PROP_ELEMENT_CLASS] = element.className,
            _a[constants.AMPLITUDE_EVENT_PROP_ELEMENT_TAG] = tag,
            _a[constants.AMPLITUDE_EVENT_PROP_ELEMENT_TEXT] = getText(element),
            _a[constants.AMPLITUDE_EVENT_PROP_ELEMENT_ARIA_LABEL] = ariaLabel,
            _a[constants.AMPLITUDE_EVENT_PROP_ELEMENT_ATTRIBUTES] = attributes,
            _a[constants.AMPLITUDE_EVENT_PROP_ELEMENT_SELECTOR] = selector,
            _a[constants.AMPLITUDE_EVENT_PROP_ELEMENT_PARENT_LABEL] = nearestLabel,
            _a[constants.AMPLITUDE_EVENT_PROP_PAGE_URL] = window.location.href.split('?')[0],
            _a[constants.AMPLITUDE_EVENT_PROP_PAGE_TITLE] = (typeof document !== 'undefined' && document.title) || '',
            _a[constants.AMPLITUDE_EVENT_PROP_VIEWPORT_HEIGHT] = window.innerHeight,
            _a[constants.AMPLITUDE_EVENT_PROP_VIEWPORT_WIDTH] = window.innerWidth,
            _a);
        if (tag === 'a' && actionType === 'click' && element instanceof HTMLAnchorElement) {
            properties[constants.AMPLITUDE_EVENT_PROP_ELEMENT_HREF] = element.href;
        }
        if (actionType === 'change') {
            properties[constants.AMPLITUDE_EVENT_PROP_ELEMENT_VALUE] = element.value;
        }
        if (trackForm) {
            // MrQ extra attributes
            // FIXME: No assertion
            properties[constants.AMPLITUDE_EVENT_PROP_ELEMENT_LABEL] = (_g = (_f = (_e = (_d = element.labels) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.textContent) === null || _f === void 0 ? void 0 : _f.trim) === null || _g === void 0 ? void 0 : _g.call(_f);
            properties[constants.AMPLITUDE_EVENT_PROP_ELEMENT_NAME] = element.name;
            properties[constants.AMPLITUDE_EVENT_PROP_ELEMENT_TITLE] = element.title;
            var form = element.form;
            if (form) {
                properties[constants.AMPLITUDE_EVENT_PROP_FORM_NAME] = form.name;
                properties[constants.AMPLITUDE_EVENT_PROP_FORM_ID] = form.id;
            }
        }
        // if (trackPosition) {
        //   /* istanbul ignore next */
        //   const rect =
        //     typeof element.getBoundingClientRect === 'function' ? element.getBoundingClientRect() : { left: null, top: null };
        //   properties[constants.AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_LEFT] = rect.left == null ? null : Math.round(rect.left);
        //   properties[constants.AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_TOP]= rect.top == null ? null : Math.round(rect.top);
        // }
        return removeEmptyProperties(properties);
    };
    var setup = function (config, amplitude) { return __awaiter(void 0, void 0, void 0, function () {
        var addListener, removeListener, attachListeners;
        var _a, _b;
        return __generator(this, function (_c) {
            if (!amplitude) {
                /* istanbul ignore next */
                (_a = config === null || config === void 0 ? void 0 : config.loggerProvider) === null || _a === void 0 ? void 0 : _a.warn("".concat(name, " plugin requires a later version of @amplitude/analytics-browser. Events are not tracked."));
                return [2 /*return*/];
            }
            logger = config.loggerProvider;
            /* istanbul ignore if */
            if (typeof document === 'undefined') {
                return [2 /*return*/];
            }
            addListener = function (el) {
                if (shouldTrackEvent('click', el)) {
                    addEventListener(el, 'click', function (event) {
                        // Limit to only the innermost element that matches the selectors, avoiding all propagated event after matching.
                        /* istanbul ignore next */
                        if ((event === null || event === void 0 ? void 0 : event.target) != (event === null || event === void 0 ? void 0 : event.currentTarget) &&
                            getClosestElement(event === null || event === void 0 ? void 0 : event.target, cssSelectorAllowlist) != (event === null || event === void 0 ? void 0 : event.currentTarget)) {
                            return;
                        }
                        /* istanbul ignore next */
                        amplitude === null || amplitude === void 0 ? void 0 : amplitude.track(constants.AMPLITUDE_ELEMENT_CLICKED_EVENT, getEventProperties('click', el));
                    });
                }
                if (shouldTrackEvent('change', el)) {
                    if (debounceChange) {
                        debouncedTracks.set(el, debounce(amplitude === null || amplitude === void 0 ? void 0 : amplitude.track.bind(amplitude), debounceChange));
                    }
                    addEventListener(el, 'change', function (event) {
                        // Limit to only the innermost element that matches the selectors, avoiding all propagated event after matching.
                        /* istanbul ignore next */
                        if ((event === null || event === void 0 ? void 0 : event.target) != (event === null || event === void 0 ? void 0 : event.currentTarget) &&
                            getClosestElement(event === null || event === void 0 ? void 0 : event.target, cssSelectorAllowlist) != (event === null || event === void 0 ? void 0 : event.currentTarget)) {
                            return;
                        }
                        var track = debounceChange ? debouncedTracks.get(el) : amplitude === null || amplitude === void 0 ? void 0 : amplitude.track.bind(amplitude);
                        var eventProperties = getEventProperties('change', el);
                        track === null || track === void 0 ? void 0 : track(constants.AMPLITUDE_ELEMENT_CHANGED_EVENT, eventProperties);
                    });
                }
            };
            removeListener = function (el) {
                var _a, _b;
                (_b = (_a = debouncedTracks.get(el)) === null || _a === void 0 ? void 0 : _a.flush) === null || _b === void 0 ? void 0 : _b.call(_a);
                debouncedTracks.delete(el);
            };
            if (typeof MutationObserver !== 'undefined') {
                observer = new MutationObserver(function (mutations) {
                    mutations.forEach(function (mutation) {
                        mutation.addedNodes.forEach(function (node) {
                            addListener(node);
                            if ('querySelectorAll' in node && typeof node.querySelectorAll === 'function') {
                                querySelectUniqueElements(node, cssSelectorAllowlist).forEach(addListener);
                            }
                        });
                        if (debounceChange) {
                            mutation.removedNodes.forEach(function (node) {
                                removeListener(node);
                                if ('querySelectorAll' in node && typeof node.querySelectorAll === 'function') {
                                    querySelectUniqueElements(node, cssSelectorAllowlist).forEach(removeListener);
                                }
                            });
                        }
                    });
                });
            }
            attachListeners = function () {
                var allElements = querySelectUniqueElements(document.body, cssSelectorAllowlist);
                allElements.forEach(addListener);
                /* istanbul ignore next */
                observer === null || observer === void 0 ? void 0 : observer.observe(document.body, {
                    subtree: true,
                    childList: true,
                });
            };
            if (document.body) {
                attachListeners();
            }
            else {
                // This is to handle the case where the plugin is loaded before the body is available.
                // E.g., for non-reactive frameworks.
                window.addEventListener('load', attachListeners);
            }
            /* istanbul ignore next */
            (_b = config === null || config === void 0 ? void 0 : config.loggerProvider) === null || _b === void 0 ? void 0 : _b.log("".concat(name, " has been successfully added."));
            return [2 /*return*/];
        });
    }); };
    var execute = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, event];
        });
    }); };
    var teardown = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (observer) {
                observer.disconnect();
            }
            removeEventListeners();
            return [2 /*return*/];
        });
    }); };
    return {
        name: name,
        type: type,
        setup: setup,
        execute: execute,
        teardown: teardown,
    };
};
//# sourceMappingURL=default-event-tracking-advanced-plugin.js.map